import React from 'react'
import { cn } from '../utils'

export const Skeleton: React.FC<{ 
    className?: string;
    animate?: boolean;
}> = ({ className, animate = true }) => (
    <div className={cn(
        'relative overflow-hidden rounded-lg bg-gray-100 dark:bg-white/5',
        animate && 'before:absolute before:inset-0 before:-translate-x-full before:animate-shimmer before:bg-gradient-to-r before:from-transparent before:via-white/20 dark:before:via-white/10 before:to-transparent',
        className
    )} />
)